import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from 'react-router-dom';
import moment from "moment";

import FetchModule from "../../../Model/Network/FetchModule";
import WodTitleInput from "../Component/WodTitleInput";
import WodEventPointBox from "../Model/WodEventPointBox";
import ProgramNoteBox from "../Model/ProgramNoteBox";
import URLInputBox from "../Model/URLInputBox";
import FlowPlanInputBox from "../Model/FlowPlanInputBox";
import RuleBookInputBox from "../Model/RuleBookInputBox";
import LoadingView from "../Model/LoadingView";
import WodDateBox from "../Model/WodDateBox";
import ScoreRuleSettingBox from "../Model/ScoreRuleSettingBox";
import ScoreRulePrevBox from "../Model/ScoreRulePrevBox";

import WhiteLeftArrow from '../../../Image/WhiteLeftArrow.png';
import ProfilePath from '../../../Image/DefaultProfile.png';

export default function WodDetailPage(props) {
  
  const navigate = useNavigate();
  const params = useParams();

  const [isEdit, setIsEdit] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);

  const [organizerId, setOrganizerId] = useState('');
  const [eventTitle, setEventTitle] = useState('');
  const [eventProfile, setEventProfile] = useState('');
  const [wods, setWods] = useState([]);
  const [clickedWodId, setClickedWodId] = useState(parseInt(params.wodId));

  const [wodSubTitle, setWodSubTitle] = useState('');
  const [wodTitle, setWodTitle] = useState('');
  const [startDate, setStartDate] = useState(moment());
  const [startTime, setStartTime] = useState('10:00');
  const [endDate, setEndDate] = useState(moment());
  const [endTime, setEndTime] = useState('23:59');
  const [sortMethod, setSortMethod] = useState('asc');
  const [pointGap, setPointGap] = useState(1);
  const [scoreRules, setScoreRules] = useState([]);
  const [wodVideo, setWodVideo] = useState('');
  const [wodProgram, setWodProgram] = useState('');
  const [wodNote, setWodNote] = useState('');
  const [wodFlowPlan, setWodFlowPlan] = useState('');
  const [wodRuleBook, setWodRuleBook] = useState('');
  const [wodRuleBookModifiedDate, setWodRuleBookModifiedDate] = useState(moment());
  const [wodViewIndex, setWodViewIndex] = useState(1);

  // Original Data (원본 데이터 백업용) //
  const [originalWodSubTitle, setOriginalWodSubTitle] = useState('');
  const [originalWodTitle, setOriginalWodTitle] = useState('');
  const [originalStartDate, setOriginalStartDate] = useState(moment());
  const [originalStartTime, setOriginalStartTime] = useState('10:00');
  const [originalEndDate, setOriginalEndDate] = useState(moment());
  const [originalEndTime, setOriginalEndTime] = useState('23:59');
  const [originalSortMethod, setOriginalSortMethod] = useState('asc');
  const [originalPointGap, setOriginalPointGap] = useState(1);
  const [originalScoreRules, setOriginalScoreRules] = useState([]);
  const [originalWodVideo, setOriginalWodVideo] = useState('');
  const [originalWodProgram, setOriginalWodProgram] = useState('');
  const [originalWodNote, setOriginalWodNote] = useState('');
  const [originalWodFlowPlan, setOriginalWodFlowPlan] = useState('');
  const [originalWodRuleBook, setOriginalWodRuleBook] = useState('');
  const [originalWodRuleBookModifiedDate, setOriginalWodRuleBookModifiedDate] = useState(moment());
  // Original Data //

  const newScoreRule = {
    // wodId: 0,
    tag: 'ForTime',
    round: 1,
    isUseTimeCap: false,
    exerciseMin: 0,
    exerciseSec: 0,
    restMin: 0,
    restSec: 0,
    customText: '',
    scoreKeyword: 'Not Scored',
    scorePriority: 'Heighter',
    isUseTieBreak: false,

    tieBreakTag: 'ForTime',
    tieBreakRound: 1,
    tieBreakIsUseTimeCap: false,
    tieBreakExerciseMin: 0,
    tieBreakExerciseSec: 0,
    tieBreakRestMin: 0,
    tieBreakRestSec: 0,
    tieBreakCustomText: '',
    tieBreakScoreKeyword: 'Not Scored',
    tieBreakScorePriority: 'Heighter',

    viewIndex: 0
  }

  // 데이터 조회 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('wod/detail/' + params.eventId, 'GET');
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setOrganizerId(responseData.data.organizerId);
          setEventTitle(responseData.data.eventTitle);
          setEventProfile(responseData.data.eventProfile);
          setWods(responseData.data.wods);
        }
      }
    )();
  }, [])

  // 선택된 와드에 따라 데이터 변환 //
  useEffect(() => {
    let selectedWod = wods.find(wod => wod.wodId === parseInt(clickedWodId));

    // 값이 없는경우 //
    if (selectedWod === undefined) {
      setWodSubTitle('');
      setWodTitle('');
      setScoreRules([newScoreRule]);
      setStartDate(moment());
      setStartTime('10:00');
      setEndDate(moment());
      setEndTime('23:59');
      setSortMethod('asc');
      setPointGap(1);
      setWodVideo('');
      setWodProgram('');
      setWodNote('');
      setWodFlowPlan('');
      setWodRuleBook('');
      setWodViewIndex(1);
    }
    // 값이 있는경우 //
    else {
      setWodSubTitle(selectedWod.wodSubTitle);
      setWodTitle(selectedWod.wodTitle);
      setScoreRules(selectedWod.scoreRules);
      setStartDate(moment(selectedWod.startDate));
      setStartTime(moment(selectedWod.startDate).format('HH:mm'));
      setEndDate(moment(selectedWod.endDate));
      setEndTime(moment(selectedWod.endDate).format('HH:mm'));
      setSortMethod(selectedWod.sortMethod);
      setPointGap(selectedWod.pointGap);
      setWodVideo(selectedWod.video);
      setWodProgram(selectedWod.program);
      setWodNote(selectedWod.note);
      setWodFlowPlan(selectedWod.flowPlan);
      setWodRuleBook(selectedWod.ruleBook);
      setWodViewIndex(selectedWod.viewIndex);

      // 원본 데이터 백업 //
      setOriginalWodSubTitle(selectedWod.wodSubTitle);
      setOriginalWodTitle(selectedWod.wodTitle);
      setOriginalScoreRules(JSON.parse(JSON.stringify(selectedWod.scoreRules)));
      setOriginalStartDate(moment(selectedWod.startDate));
      setOriginalStartTime(moment(selectedWod.startDate).format('HH:mm'));
      setOriginalEndDate(moment(selectedWod.endDate));
      setOriginalEndTime(moment(selectedWod.endDate).format('HH:mm'));
      setOriginalSortMethod(selectedWod.sortMethod);
      setOriginalPointGap(selectedWod.pointGap);
      setOriginalWodVideo(selectedWod.video);
      setOriginalWodProgram(selectedWod.program);
      setOriginalWodNote(selectedWod.note);
      setOriginalWodFlowPlan(selectedWod.flowPlan);
      setOriginalWodRuleBook(selectedWod.ruleBook);
      setOriginalWodRuleBookModifiedDate(moment());
    }
  }, [wods, clickedWodId])

  // 이벤트 컬럼 이름 결정 //
  function decideEventColumn(data) {
    if (data.wodSubTitle === undefined || data.wodSubTitle === '') return 'Event ' + data.viewIndex;
    else return data.wodSubTitle;
  }

  // 이벤트 디비전 이름 정리 //
  function decideEventDivisionName() {
    if (wodSubTitle === '') return 'Event ' + wodViewIndex;
    else return wodSubTitle;
  }

  // 뒤로가기 버튼 클릭시 //
  function onClickGoBack() {
    navigate('/note/' + organizerId);
  }

  // 와드 클릭시 //
  function onClickWod(data) {
    setClickedWodId(data.wodId);
  }

  // 메인 점수 기준 변경시 //
  function onChangeMainTag(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tag = value;
    setScoreRules(newScoreRules);
  }

  // 메인 타임캡 사용여부 변경시 //
  function onChangeMainIsUseTimeCap(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].isUseTimeCap = value;
    setScoreRules(newScoreRules);
  }

  // 메인 라운드 변경시 //
  function onChangeMainRound(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].round = value;
    setScoreRules(newScoreRules);
  }
  
  // 메인 운동시간(초) 변경시 //
  function onChangeMainExerciseMin(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].exerciseMin = value;
    setScoreRules(newScoreRules);
  }

  // 메인 운동시간(초) 변경시 //
  function onChangeMainExerciseSec(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].exerciseSec = value;
    setScoreRules(newScoreRules);
  }
  
  // 메인 휴식시간(초) 변경시 //
  function onChangeMainRestMin(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].restMin = value;
    setScoreRules(newScoreRules);
  }

  // 메인 휴식시간(초) 변경시 //
  function onChangeMainRestSec(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].restSec = value;
    setScoreRules(newScoreRules);
  }

  // 메인 운동 점수기록 방식 설명 변경시 //
  function onChangeMainCustomText(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].customText = value;
    setScoreRules(newScoreRules);
  }

  // 메인 운동 점수기록 방식 변경시 //
  function onChangeMainScoreKeyword(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].scoreKeyword = value;
    setScoreRules(newScoreRules);
  }

  // 메인 운동 점수기록 방식 변경시 //
  function onChangeMainScorePriority(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].scorePriority = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 사용여부 변경시 //
  function onChangeIsUseTieBreak(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].isUseTieBreak = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 사용여부 변경시 //
  function onChangeIsUseTieBreak(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].isUseTieBreak = value;
    setScoreRules(newScoreRules);
  }


  // 타이브레이크 점수 기준 변경시 //
  function onChangeTieBreakTag(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakTag = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 타임캡 사용여부 변경시 //
  function onChangeTieBreakIsUseTimeCap(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakIsUseTimeCap = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 라운드 변경시 //
  function onChangeTieBreakRound(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakRound = value;
    setScoreRules(newScoreRules);
  }
  
  // 타이브레이크 운동시간(초) 변경시 //
  function onChangeTieBreakExerciseMin(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakExerciseMin = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 운동시간(초) 변경시 //
  function onChangeTieBreakExerciseSec(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakExerciseSec = value;
    setScoreRules(newScoreRules);
  }
  
  // 타이브레이크 운동시간(초) 변경시 //
  function onChangeTieBreakRestMin(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakRestMin = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 운동시간(초) 변경시 //
  function onChangeTieBreakRestSec(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakRestSec = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 운동 점수기록 방식 설명 변경시 //
  function onChangeTieBreakCustomText(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakCustomText = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 운동 점수기록 방식 변경시 //
  function onChangeTieBreakScoreKeyword(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakScoreKeyword = value;
    setScoreRules(newScoreRules);
  }

  // 타이브레이크 운동 점수기록 방식 변경시 //
  function onChangeTieBreakScorePriority(value, index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules[index].tieBreakScorePriority = value;
    setScoreRules(newScoreRules);
  }

  // 점수기준 추가 클릭시 //
  function onClickAddScoreRule() {
    let newScoreRules = scoreRules.slice();
    
    newScoreRules.push(newScoreRule);
    setScoreRules(newScoreRules);
  }

  // 점수기준 삭제 클릭시 //
  function onClickDeleteScoreRule(index) {
    let newScoreRules = scoreRules.slice();

    newScoreRules.splice(index, 1);
    setScoreRules(newScoreRules);
  }
  
  // 플로우 플랜 업로드시 //
  function uploadFlowPlan(flowPlan) {
    if (isInProgress) {
      alert('저장을 진행중입니다');
      return;
    }

    setIsInProgress(true);

    let requestData = {
      wodId: clickedWodId,
      flowPlan: flowPlan
    }
    // console.log(requestData);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('wod/save/flow_plan', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setWodFlowPlan(responseData.data);
          setIsInProgress(false);
        }
        else {
          alert('저장을 실패했습니다\n잠시 후 다시시도해주세요');
          setIsInProgress(false);
        }
      }
    )();
  }

  // 플로우 플랜 삭제시 //
  function deleteFlowPlan() {
    if (isInProgress) {
      alert('삭제를 진행중입니다');
      return;
    }

    setIsInProgress(true);

    let requestData = {
      wodId: clickedWodId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('wod/delete/flow_plan', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setWodFlowPlan('');
          setIsInProgress(false);
        }
        else {
          alert('삭제를 실패했습니다\n잠시 후 다시시도해주세요');
          setIsInProgress(false);
        }
      }
    )();
  }

  // PDF파일 선택시 //
  function uploadRuleBook(file, fileName) {
    if (isInProgress) {
      alert('저장을 진행중입니다');
      return;
    }

    setIsInProgress(true);

    let requestData = {
      wodId: clickedWodId,
      ruleBook: file.toString(),
      fileName: fileName
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('wod/save/rule_book', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setWodRuleBook(responseData.data.ruleBook);
          setWodRuleBookModifiedDate(responseData.data.modifiedDate);
          setIsInProgress(false);
        }
        else {
          alert('저장을 실패했습니다\n잠시 후 다시시도해주세요');
          setIsInProgress(false);
        }
      }
    )();
  };

  // PDF파일 선택시 //
  function downloadRuleBook() {
    const url = wodRuleBook;

    // 📌 파일 이름 추출 (URL 마지막 부분)
    const fileName = url.split('/').pop();
  
    const link = document.createElement('a');
    link.href = url;
    link.download = decodeURIComponent(fileName); // 인코딩된 한글 파일도 처리 가능
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // PDF파일 삭제 클릭시 //
  function deleteRuleBook() {
    if (!isEdit) {
      return;
    }
    else if (isInProgress) {
      alert('삭제를 진행중입니다');
      return;
    }

    setIsInProgress(true);

    let requestData = {
      wodId: clickedWodId,
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('wod/delete/rule_book', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setWodRuleBook('');
          setWodRuleBookModifiedDate(moment().format('YYYY-MM-DDTHH:mm:ss'));
          setIsInProgress(false);
        }
        else {
          alert('삭제을 실패했습니다\n잠시 후 다시시도해주세요');
          setIsInProgress(false);
        }
      }
    )();
  };

  // 취소 클릭시 //
  function onClickExit() {
    if (!isEdit) return;

    // 원본 데이터로 복원 //
    setWodSubTitle(originalWodSubTitle);
    setWodTitle(originalWodTitle);
    setScoreRules(JSON.parse(JSON.stringify(originalScoreRules)));
    setStartDate(moment(originalStartDate));
    setStartTime(originalStartTime);
    setEndDate(moment(originalEndDate));
    setEndTime(originalEndTime);
    setSortMethod(originalSortMethod);
    setPointGap(originalPointGap);
    setWodVideo(originalWodVideo);
    setWodProgram(originalWodProgram);
    setWodNote(originalWodNote);
    setWodFlowPlan(originalWodFlowPlan);
    setWodRuleBook(originalWodRuleBook);
    setWodRuleBookModifiedDate(moment(originalWodRuleBookModifiedDate));

    setIsEdit(false);
  }

  // 저장 클릭시 //
  function onClickSave() {
    if (!isEdit) {
      // 수정 모드 진입 시 현재 데이터를 원본으로 백업 //
      setOriginalWodSubTitle(wodSubTitle);
      setOriginalWodTitle(wodTitle);
      setOriginalScoreRules(JSON.parse(JSON.stringify(scoreRules)));
      setOriginalStartDate(moment(startDate));
      setOriginalStartTime(startTime);
      setOriginalEndDate(moment(endDate));
      setOriginalEndTime(endTime);
      setOriginalSortMethod(sortMethod);
      setOriginalPointGap(pointGap);
      setOriginalWodVideo(wodVideo);
      setOriginalWodProgram(wodProgram);
      setOriginalWodNote(wodNote);
      setOriginalWodFlowPlan(wodFlowPlan);
      setOriginalWodRuleBook(wodRuleBook);
      setOriginalWodRuleBookModifiedDate(moment(wodRuleBookModifiedDate));

      setIsEdit(true);
      return;
    }

    if (isEdit) {
      if (isInProgress) {
        alert('저장을 진행중입니다');
        return;
      }
      else if (wodSubTitle === '') {
        alert('이벤트 컬럼명을 입력해주세요');
        return;
      }
      else if (wodTitle === '') {
        alert('와드 이름을 입력해주세요');
        return;
      }
      else if (pointGap === '' || pointGap === 0) {
        alert('순위별 포인트 간격을 설정해주세요');
        return;
      }
      else if (wodProgram === '') {
        alert('이벤트 내용을 입력해주세요');
        return;
      }

      const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;

      if (!timePattern.test(startTime) && startTime !== '') {
        alert('시작시각을 올바르게 입력해주세요');
        return;
      }
      else if (!timePattern.test(endTime) && endTime !== '') {
        alert('종료시각을 올바르게 입력해주세요');
        return;
      }
      
      setIsInProgress(true);
      
      let selectedWod = wods.find(wod => wod.wodId === parseInt(clickedWodId));
      let finalScoreRules = scoreRules.slice();

      for (let i = 0; i < finalScoreRules.length; i++) {
        finalScoreRules[i].wodId = selectedWod.wodId;
        finalScoreRules[i].viewIndex = (i + 1);
      }

      let newStartTime = startTime === '' ? '00:00' : startTime;
      let newEndTime = endTime === '' ? '00:00' : endTime;
      let finalStartDate = startDate.format('YYYY-MM-DDT') + newStartTime + ':00';
      let finalEndDate = endDate.format('YYYY-MM-DDT') + newEndTime + ':00';
      
      let requestData = {
        eventId: parseInt(params.eventId),
        wodId: selectedWod.wodId,
        wodSubTitle: wodSubTitle,
        wodTitle: wodTitle,
        startDate: finalStartDate,
        endDate: finalEndDate,
        sortMethod: sortMethod,
        pointGap: pointGap,
        video: wodVideo,
        program: wodProgram,
        note: wodNote,
        scoreRules: finalScoreRules
      }
      
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataOfEventVer2('wod/save', 'POST', requestData);
          // console.log(responseData.data);
          if (responseData.status === 200) {
            setEventTitle(responseData.data.eventTitle);
            setEventProfile(responseData.data.eventProfile);
            setWods(responseData.data.wods);
            setIsInProgress(false);
            setIsEdit(false);
          }
          else {
            alert('저장에 실패했습니다\n잠시 후 다시시도해주세요');
            setIsInProgress(false);
          }
        }
      )();
    }
    else setIsEdit(true);
  }

  return (
    <TopLevelWrapper>
      { isInProgress && <LoadingView/> }
      <TopNavigationWrapper>
        <NavigateButtonWrapper>
          <GoBackButton onClick={onClickGoBack}>
            <GoBackInnerWrapper>
              <ArrowImage src={WhiteLeftArrow}/>
            </GoBackInnerWrapper>
          </GoBackButton>
          <EventProfileBox>
            <EventProfile src={eventProfile === '' ? ProfilePath : eventProfile}/>
          </EventProfileBox>
          <EventTitleBox>
            <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#FFFFFF' cursor='default'>{eventTitle}</Text>
          </EventTitleBox>
          {
            wods.map((data, index) => (
              <WodTitleBox 
                key={'Wod-' + index} 
                isClicked={data.wodId === clickedWodId}
                onClick={() => onClickWod(data)}>
                <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#FFFFFF' cursor='pointer'>{decideEventColumn(data)}</Text>
              </WodTitleBox>
            ))
          }
        </NavigateButtonWrapper>
        <ButtonWrapper>
          <ExitButton isClicked={isEdit} onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor={isEdit ? 'pointer' : 'default'}>취소하기</Text>
          </ExitButton>
          <SaveButton onClick={onClickSave} backgroundColor={isEdit ? '#6DD49E': '#909090'}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='pointer'>{isEdit ? '저장하기' : '수정하기'}</Text>
          </SaveButton>
        </ButtonWrapper>
      </TopNavigationWrapper>

      <WidthDivisionLine/>

      <TotalSettingView>
        <WodSettingBox>
          <TitleTotalWrapper>
            <SubTitleWrapper>
              <WodTitleInput 
                value={wodSubTitle} 
                setValue={setWodSubTitle} 
                isEdit={isEdit}
                placeholder={'Event ' + wodViewIndex}/>
            </SubTitleWrapper>
            <TitleWrapper>
              <WodTitleInput 
                value={wodTitle} 
                setValue={setWodTitle} 
                isEdit={isEdit}
                placeholder={'오늘의 와드 제목 : ' + moment().format('YYYY.MM.DD')}/>
            </TitleWrapper>
          </TitleTotalWrapper>

          <WidthGreenDivisionLine/>

          <ComponentWrapper>
            <WodDateBox
              isEdit={isEdit}
              startDate={startDate}
              setStartDate={setStartDate}
              startTime={startTime}
              setStartTime={setStartTime}
              endDate={endDate}
              setEndDate={setEndDate}
              endTime={endTime}
              setEndTime={setEndTime}/>
          </ComponentWrapper>

          <WidthGreenDivisionLine/>

          <ComponentWrapper>
            <WodEventPointBox 
              isEdit={isEdit}
              sortMethod={sortMethod}
              setSortMethod={setSortMethod}
              pointGap={pointGap}
              setPointGap={setPointGap}/>
          </ComponentWrapper>

          <WidthGreenDivisionLine/>

          {
            scoreRules.map((data, index) => (
              <ComponentWrapper key={'ScoreRuleSetting-' + index}>
                <ComponentWrapper style={{ position: 'relative', zIndex: 100 - index }}>
                  <ScoreRuleSettingBox 
                    isEdit={isEdit}
                    data={data} 
                    index={index}
                    size={scoreRules.length}

                    onChangeMainTag={onChangeMainTag}
                    onChangeMainIsUseTimeCap={onChangeMainIsUseTimeCap}
                    onChangeMainRound={onChangeMainRound}
                    onChangeMainExerciseMin={onChangeMainExerciseMin}
                    onChangeMainExerciseSec={onChangeMainExerciseSec}
                    onChangeMainRestMin={onChangeMainRestMin}
                    onChangeMainRestSec={onChangeMainRestSec}
                    onChangeMainCustomText={onChangeMainCustomText}
                    onChangeMainScoreKeyword={onChangeMainScoreKeyword}
                    onChangeMainScorePriority={onChangeMainScorePriority}
                    onChangeIsUseTieBreak={onChangeIsUseTieBreak}
                    
                    onChangeTieBreakTag={onChangeTieBreakTag}
                    onChangeTieBreakIsUseTimeCap={onChangeTieBreakIsUseTimeCap}
                    onChangeTieBreakRound={onChangeTieBreakRound}
                    onChangeTieBreakExerciseMin={onChangeTieBreakExerciseMin}
                    onChangeTieBreakExerciseSec={onChangeTieBreakExerciseSec}
                    onChangeTieBreakRestMin={onChangeTieBreakRestMin}
                    onChangeTieBreakRestSec={onChangeTieBreakRestSec}
                    onChangeTieBreakCustomText={onChangeTieBreakCustomText}
                    onChangeTieBreakScoreKeyword={onChangeTieBreakScoreKeyword}
                    onChangeTieBreakScorePriority={onChangeTieBreakScorePriority}
                    
                    onClickDeleteScoreRule={onClickDeleteScoreRule}
                    onClickAddScoreRule={onClickAddScoreRule}/>
                </ComponentWrapper>

                <WidthGreenDivisionLine/>
              </ComponentWrapper>
            ))
          }

          <ComponentWrapper>
            <URLInputBox
              isEdit={isEdit}
              value={wodVideo}
              setValue={setWodVideo}
              placeholder={isEdit ? '이벤트 룰북 영상 링크를 입력해주세요' :  ''}/>
          </ComponentWrapper>

          <WidthGreenDivisionLine/>

          <ComponentWrapper>
            <ProgramNoteBox 
              isEdit={isEdit}
              columnTitle='이벤트 내용'
              explanation='이벤트 내용을 입력해주세요'
              boxText='Program'
              boxColor='#969696'
              value={wodProgram}
              setValue={setWodProgram}
              placeholder={isEdit ? '이벤트 내용을 입력해주세요' : ''}/>
          </ComponentWrapper>

          <WidthGreenDivisionLine/>

          <ComponentWrapper>
            <ProgramNoteBox 
              isEdit={isEdit}
              columnTitle='주의사항'
              explanation='이벤트 진행시 주의사항을 입력해주세요'
              boxText='Note'
              boxColor='#FF8B48'
              value={wodNote}
              setValue={setWodNote}
              placeholder={isEdit ? '이벤트 진행시 주의사항을 입력해주세요' : ''}/>
          </ComponentWrapper>

          <WidthGreenDivisionLine/>

          <ComponentWrapper>
            <FlowPlanInputBox 
              isEdit={isEdit}
              division={decideEventDivisionName()}
              value={wodFlowPlan} 
              setValue={setWodFlowPlan}
              uploadFlowPlan={uploadFlowPlan}
              deleteFlowPlan={deleteFlowPlan}/>
          </ComponentWrapper>

          <WidthGreenDivisionLine/>

          <ComponentWrapper style={{ marginBottom: '20px' }}>
            <RuleBookInputBox
              isEdit={isEdit}
              division={decideEventDivisionName()}
              value={wodRuleBook} 
              setValue={setWodRuleBook}
              modifiedDate={wodRuleBookModifiedDate}
              uploadRuleBook={uploadRuleBook}
              downloadRuleBook={downloadRuleBook}
              deleteRuleBook={deleteRuleBook}/>
          </ComponentWrapper>
        </WodSettingBox>

        <HeightDivisionLine/>

        <WodPreviewBox>
          {
            scoreRules.map((scoreRule, scoreRuleIndex) => (
              <ScoreRulePrevBoxWrapper key={'ScoreRule-' + scoreRuleIndex}>
                <ScoreRulePrevBox
                  scoreRule={scoreRule}
                  scoreRuleIndex={scoreRuleIndex}/>
                { (scoreRuleIndex + 1) !== scoreRules.length && <SmallWidthDivisionLine/> }
              </ScoreRulePrevBoxWrapper>
            ))
          }
        </WodPreviewBox>
      </TotalSettingView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 94%;
  height: 100%;
`;

const TopNavigationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const NavigateButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 20px;

  height: 36px;

  border-radius: 30px;
  background-color: #909090;

  opacity: ${props => props.isClicked ? 1 : 0};

  :hover {
    cursor: ${props => props.isClicked ? 'pointer' : 'default'};
  }

  transition: all 0.3s ease-in-out;
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 20px;

  height: 36px;

  border-radius: 30px;
  background-color: ${props => props.backgroundColor};

  :hover {
    cursor: pointer;
  }
`;


const GoBackButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;

  border-radius: 32px;
  background-color: #FFFFFF;

  :hover {
    cursor: pointer;
  }
`;

const GoBackInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 28px;
  height: 28px;

  border-radius: 30px;
  background-color: #000000;
`;

const ArrowImage = styled.img`
  width: 8px;
  height: 13px;
`;

const EventProfileBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 5px;
  
  overflow: hidden;
`;

const EventProfile = styled.img`
  width: 100%;
  height: 100%;
`;

const EventTitleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  height: 22px;

  border-radius: 10px;
  background-color: #2F2F32;
`;

const WodTitleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 10px;

  min-width: 20px;
  height: 22px;

  border-radius: 10px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#000000`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const WidthDivisionLine = styled.div`
  margin: 35px 0px;
  // padding: 35px 0px;

  padding-top: 1px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: #E5E5E5;
`;

const TotalSettingView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const WodSettingBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 56%;
`;

const WodPreviewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 38%;
  
  border-radius: 10px;
  background-color: #17171B;
`;

const ScoreRulePrevBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const WidthGreenDivisionLine = styled.div`
  margin: 24px 0px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: #6DD49E;
`;

const HeightDivisionLine = styled.div`
  margin: 10px 0px;

  width: 1px;
  height: calc(100% - 20px);

  border-radius: 2px;
  background-color: #4E8168;
`;

const TitleTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 15px 15px 20px 15px;

  width: calc(100% - 30px);

  gap: 10px;
  
  border-radius: 10px;
  background-color: #17171B;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: calc(87% - 5px);

  border-radius: 10px;
  background-color: #17171B;
`;

const SubTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: calc(13% - 5px);

  border-radius: 10px;
  background-color: #17171B;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const SmallWidthDivisionLine = styled.div`
  width: calc(100% - 30px);
  height: 1px;

  border-radius: 2px;
  background-color: #E5E5E5;
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
